import { SharedEnv } from './environment.type';
import { apiSubdomainEnv } from './api-subdomain/environment.default';
import { environmentSpecificEnv } from './environment/environment.default';

export const environment: SharedEnv = {
  ...environmentSpecificEnv,
  ...apiSubdomainEnv,
};
